import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, computed, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { defaultTheme } from '../../../../_constants/appSetting.constant';
import { LOCALSTORAGEKEYS } from '../../../../_constants/localStorageKeys';
import { CLF_MEETING_VIEW_ROLES, roles } from '../../../../_constants/roles';
import { AppSettingService } from '../../../../_services/_appSetting/app-setting.service';
import { LocalService } from '../../../../_services/_storage/local.service';

export interface IMenuItem {
    children?: IMenuItem[];
    icon?: string;
    isSNAMenu?: boolean;
    label: string;
    path?: string;
    queryParams?: any;
    roles: string[];
    type?: string;
}

@Component({
    selector: 'lokos-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrl: './side-menu.component.scss',
    standalone: false,
})
export class SideMenuComponent implements OnInit {
    baseMenuList: IMenuItem[] = [
        {
            type: 'sub',
            label: 'dashboard',
            icon: '/assets/images/dashboard.svg',
            roles: [],
            children: [
                {
                    label: 'home',
                    path: '/main/dashboard/home',
                    roles: [roles.ALL],
                },
                {
                    label: 'lakhpatiDidi',
                    path: '/main/dashboard/lakhpati-didi-dashboard',
                    roles: [roles.ALL],
                },
            ],
        },
        {
            type: 'sub',
            label: 'userMapping',
            icon: '/assets/images/userMapping.svg',
            roles: [],
            children: [
                {
                    label: 'crpMapping',
                    path: '/main/user-mapping/crp-mapping',
                    roles: [roles.BA],
                },
                {
                    label: 'cboMapping',
                    path: '/main/user-mapping/cbo-mapping',
                    roles: [roles.BA],
                },
                {
                    label: 'geographyMapping',
                    path: '/main/user-mapping/geography-mapping',
                    roles: [roles.BA],
                },
            ],
        },
        {
            type: 'sub',
            label: 'shg',
            icon: '/assets/images/shg.svg',
            roles: [],
            children: [
                {
                    label: 'shgProfile',
                    path: '/main/profile/shg-profile',
                    roles: [
                        roles.BA,
                        roles.BMIB,
                        roles.BTSISD,
                        roles.DA,
                        roles.DTSISD,
                        roles.DMIB,
                        roles.SA,
                        roles.STSISD,
                        roles.SMIB,
                        roles.NA,
                        roles.NTSISD,
                        roles.NMIB,
                        roles.CLF_BK,
                    ],
                },
                {
                    label: 'shgMeeting',
                    path: '/main/shg-meeting',
                    roles: [roles.BMIB, roles.CLF_BK],
                },
            ],
        },
        {
            type: 'sub',
            label: 'pendingRequest',
            icon: '/assets/images/pendingRequest.svg',
            roles: [],
            children: [
                {
                    label: 'shgPending',
                    path: '/main/profile/shg-pending-request',
                    roles: [roles.BMIB],
                },
                {
                    label: 'voPending',
                    path: '/main/profile/vo-pending-request',
                    roles: [roles.BMIB],
                },
                {
                    label: 'clfPending',
                    path: '/main/profile/clf-pending-request',
                    roles: [roles.BMIB],
                },
                {
                    label: 'pfmsPending',
                    path: '/main/profile/pfms-pending-request',
                    roles: [roles.BMIB],
                },
            ],
        },
        {
            type: 'sub',
            label: 'federation',
            icon: '/assets/images/federation.svg',
            roles: [],
            children: [
                {
                    label: 'voProfile',
                    path: '/main/profile/vo-profile',
                    roles: [
                        roles.BA,
                        roles.BTSISD,
                        roles.BMIB,
                        roles.DA,
                        roles.DTSISD,
                        roles.DMIB,
                        roles.SA,
                        roles.STSISD,
                        roles.SMIB,
                        roles.NA,
                        roles.NTSISD,
                        roles.NMIB,
                        roles.CLF_BK,
                    ],
                },
                {
                    label: 'voMeeting',
                    path: '/main/vo-meeting',
                    roles: [roles.BMIB, roles.CLF_BK],
                },
                {
                    label: 'clfProfile',
                    path: '/main/profile/clf-profile',
                    roles: [
                        roles.BA,
                        roles.BTSISD,
                        roles.BMIB,
                        roles.DA,
                        roles.DTSISD,
                        roles.DMIB,
                        roles.SA,
                        roles.STSISD,
                        roles.SMIB,
                        roles.NA,
                        roles.NTSISD,
                        roles.NMIB,
                        roles.CLF_BK,
                    ],
                },
                // {
                //     label: 'clfMeetingDetail',
                //     path: '/main/profile/clf-meeting',
                //     roles: [roles.BMIB],
                // },
                {
                    label: 'clfMeeting',
                    path: '/main/transaction/clf-meeting',
                    roles: CLF_MEETING_VIEW_ROLES,
                },
                {
                    label: 'fundDeploymentMonitoring',
                    path: '/main/transaction/clf-meeting/fund-deployment-monitoring',
                    roles: [roles.CLF_BK],
                },
            ],
        },
        {
            type: 'sub',
            label: 'lakhpatiDidi',
            icon: '/assets/images/lakhpatiDidi.svg',
            roles: [roles.DTF, roles.BTF],
            children: [
                {
                    label: 'identification',
                    path: '/main/lakhpati-didi/status',
                    roles: [roles.DTF, roles.BTF],
                },
                {
                    label: 'verification',
                    path: '/main/lakhpati-didi/verification',
                    roles: [roles.BTF],
                },
            ],
        },
        {
            type: 'sub',
            label: 'aajeevika',
            icon: '/assets/images/aajeevika.svg',
            roles: [roles.BTF],
            children: [
                {
                    label: 'aajeevikaRegister',
                    path: '/main/aajeevika/memberList',
                    roles: [roles.BTF],
                },
                {
                    label: 'enterpriseRegister',
                    path: '/main/aajeevika/epdt',
                    roles: [roles.BTF],
                },
            ],
        },
        {
            type: 'sub',
            label: 'reports',
            icon: '/assets/images/reports.svg',
            roles: [],
            children: [
                {
                    label: 'profileReports',
                    path: '/main/reports/profile-reports',
                    roles: [
                        roles.BA,
                        roles.BRV,
                        roles.BMIB,
                        roles.DA,
                        roles.DRV,
                        roles.DMIB,
                        roles.SA,
                        roles.SRV,
                        roles.SMIB,
                        roles.NA,
                        roles.NRV,
                        roles.NMIB,
                        roles.NTF,
                        roles.STF,
                        roles.DTF,
                        roles.BTF,
                        roles.NTSISD,
                        roles.STSISD,
                        roles.DTSISD,
                        roles.BTSISD,
                    ],
                },
                {
                    label: 'transactionReports',
                    path: '/main/reports/transaction-reports',
                    roles: [
                        roles.BA,
                        roles.BRV,
                        roles.DA,
                        roles.DRV,
                        roles.DMIB,
                        roles.SA,
                        roles.SRV,
                        roles.SMIB,
                        roles.NA,
                        roles.NRV,
                        roles.NMIB,
                        roles.NTSISD,
                        roles.STSISD,
                        roles.DTSISD,
                        roles.BTSISD,
                        roles.CLF_BK,
                    ],
                },
                {
                    label: 'fundReports',
                    path: '/main/reports/fund-reports',
                    roles: [
                        roles.BA,
                        roles.BRV,
                        roles.BMIB,
                        roles.DA,
                        roles.DRV,
                        roles.DMIB,
                        roles.SA,
                        roles.SRV,
                        roles.SMIB,
                        roles.NA,
                        roles.NRV,
                        roles.NMIB,
                        roles.NTSISD,
                        roles.STSISD,
                        roles.DTSISD,
                        roles.BTSISD,
                    ],
                },
                {
                    label: 'scorecard',
                    path: '/main/reports/scorecard',
                    roles: [
                        roles.BA,
                        roles.BRV,
                        roles.BMIB,
                        roles.DA,
                        roles.DRV,
                        roles.DMIB,
                        roles.SA,
                        roles.SRV,
                        roles.SMIB,
                        roles.NA,
                        roles.NRV,
                        roles.NMIB,
                        roles.NTSISD,
                        roles.STSISD,
                        roles.DTSISD,
                        roles.BTSISD,
                    ],
                },
            ],
        },
    ];

    collapsed = signal(false);
    isSNAStateLoggedIn = false;
    menuPaths = computed(() => this.collectPaths(this.menuItems()));
    menuItems = computed(() => {
        const roles = this.userRoles();
        const isSNA = this.isSNAStateLoggedIn;

        if (!roles.length) return [];

        const hasAccess = (allowed: string[] = []) =>
            allowed.includes('all') || allowed.some((r) => roles.includes(r));

        return this.baseMenuList
            .map((item) => {
                return {
                    ...item,
                    children: item.children?.filter(
                        (child) =>
                            hasAccess(child.roles) &&
                            (isSNA || !child.isSNAMenu)
                    ),
                };
            })
            .filter((item) => {
                if (item.type === 'link') {
                    return hasAccess(item.roles) && (isSNA || !item.isSNAMenu);
                }
                return item.children?.length;
            });
    });
    theme: string = defaultTheme;
    userRoles = signal<string[]>([]);
    private prevCollapsed = false;
    private wasOnReports = false;

    constructor(
        private appSettingService: AppSettingService,
        private breakpointObserver: BreakpointObserver,
        private localService: LocalService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.breakpointObserver
            .observe(['(min-width: 900px)'])
            .subscribe((state: BreakpointState) => {
                if (state.matches) {
                    this.collapsed.set(false);
                } else {
                    this.collapsed.set(true);
                }
            });

        this.appSettingService.appTheme$.subscribe(
            (theme) => (this.theme = theme)
        );
        const roles = this.localService.get(LOCALSTORAGEKEYS.USERROLES) || [];
        this.userRoles.set(roles);

        this.handleReportsAutoCollapse(this.router.url);
        this.router.events
            .pipe(filter((e) => e instanceof NavigationEnd))
            .subscribe((e) => {
                this.handleReportsAutoCollapse(
                    (e as NavigationEnd).urlAfterRedirects
                );
            });
    }

    private handleReportsAutoCollapse(url: string): void {
        const onReports = url.startsWith('/main/reports');
        if (onReports) {
            if (!this.wasOnReports) {
                this.prevCollapsed = this.collapsed();
            }
            this.collapsed.set(true);
            this.wasOnReports = true;
        } else {
            if (this.wasOnReports) {
                this.collapsed.set(this.prevCollapsed);
            }
            this.wasOnReports = false;
        }
    }

    private collectPaths(items: IMenuItem[]): string[] {
        const paths: string[] = [];
        for (const item of items) {
            if (item.path) paths.push(item.path);
            if (item.children?.length) {
                paths.push(...this.collectPaths(item.children));
            }
        }
        return paths;
    }
}
